/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Share: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.7071 3.29289C12.5196 3.10536 12.2652 3 12 3C11.7348 3 11.4804 3.10536 11.2929 3.29289L7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711C7.68342 9.09763 8.31658 9.09763 8.70711 8.70711L11 6.41421V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V6.41422L15.2929 8.70711C15.6834 9.09763 16.3166 9.09763 16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289L12.7071 3.29289ZM6 16C6 15.4477 5.55228 15 5 15C4.44772 15 4 15.4477 4 16V18C4 19.6569 5.34315 21 7 21H17C18.6569 21 20 19.6569 20 18V16C20 15.4477 19.5523 15 19 15C18.4477 15 18 15.4477 18 16V18C18 18.5523 17.5523 19 17 19H7C6.44772 19 6 18.5523 6 18V16Z'
      fill='currentColor'
    />
  </React.Fragment>
)
